import React, { useState, useEffect } from "react";
import styles from "./Contact.module.css";
import axios from "../api/axios";
import DashBoardLayout from "./DashBoardLayout";
import { Modal, Button } from "react-bootstrap";
import DeleteIcon from "../assets/Frame.png"; // same delete icon used in invoice list
import { useNavigate } from 'react-router-dom';
import EditIcon from "../assets/edit-button-svgrepo-com.svg";
import {toast} from 'sonner';

function Contact() {
  const [name, setName] = useState("");
  const [newTin, setNewTin] = useState(''); // modal input
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [phonenumber, setPhoneNumber] = useState(""); 
  const [show, setShow] = useState(false);
  const [user, setUser] = useState();
  const [contacts, setContacts] = useState([]);
  const [query, setQuery] = useState("");
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [selectedContact, setSelectedContact] = useState({
  contactId: "",
  customerName: "",
  customerEmail: "",
  customerAddress: "",
  customerTin: "",
  customerPhoneNumber: "",
  userId: "",
});

const handleEdit = (contact) => {
  setSelectedContact(contact);
  setIsEditModalOpen(true);
};

const handleEditChange = (e) => {
  const { name, value } = e.target;
  setSelectedContact((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSaveEdit = async () => {
  try {
    await axios.put(`api/v1/contact/EditContact/${selectedContact.contactId}`, selectedContact);
    toast.success("Contact updated successfully");
    //alert("Contact updated successfully!");
    setIsEditModalOpen(false);
    // Refresh contact list after save
    getContacts(user?.id);
  } catch (error) {
    console.error("Error updating contact:", error);
    toast.error("Failed to update contact");
    //alert("Failed to update contact.");
  }
};


  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(5);

  const ADDCONTACT_URL = "api/v1/Contact/AddContact";
  const GETCONTACTS_URL = "api/v1/Contact/GetContactByUser/";
  const DELETECONTACT_URL = "api/v1/Contact/delete/";

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
 const navigate = useNavigate();

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setUser(foundUser);
      getContacts(foundUser?.id);
    }
    else{
        navigate("/login");
    }
  }, [navigate]);

  const getContacts = async (userId) => {
    try {
      const response = await axios.get(GETCONTACTS_URL + userId);
      if (response.status === 200) {
        setContacts(response.data);
        setFilteredContacts(response.data);
      } else {
        toast.error("Error fetching contacts")
       // alert("Error fetching contacts");
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        ADDCONTACT_URL,
        {
          customerName: name,
          customerEmail: email,
          customerAddress: address,
          customerPhoneNumber: phonenumber,
          customerTin : newTin,
          userId: user?.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        handleClose();
        setName("");
        setEmail("");
        setAddress("");
        setPhoneNumber("");
        getContacts(user?.id);
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  const handleDelete = async (Id) => {
    if (!window.confirm("Are you sure you want to delete this contact?")) return;

    try {
      const response = await axios.delete(DELETECONTACT_URL + Id);
      if (response.status === 200) {
        toast.success("Contact deleted successfully");
        //alert("Contact deleted successfully");
        getContacts(user?.id);
      } else {
        toast.error("Error deleting contact");
        //alert("Error deleting contact");
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  // Search contacts by name or email
  useEffect(() => {
    const lowerQuery = query.toLowerCase();
    const filtered = contacts.filter(
      (contact) =>
        contact.customerName.toLowerCase().includes(lowerQuery) ||
        contact.customerEmail.toLowerCase().includes(lowerQuery)
    );
    setFilteredContacts(filtered);
    setCurrentPage(1);
  }, [query, contacts]);

  // Pagination logic
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentContacts = filteredContacts.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredContacts.length / entriesPerPage);

  return (
    <div>
      <DashBoardLayout />
      <div className={styles.invoicelist_container}>
        <div id={styles.invoice_header}>
          <h4>Contact</h4>
          <button onClick={handleShow} id={styles.createnewbtn}>
            Create New
          </button>
        </div>

        <div id={styles.params}>
          <div id={styles.shownumber}>
            <p>Show</p>
            <input
              type="number"
              id={styles.numberentry}
              min="1"
              max="50"
              value={entriesPerPage}
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
            />
            <p>entries</p>
          </div>
          <div id={styles.search}>
            <p>Search</p>
            <input
              type="text"
              id={styles.searchentry}
              placeholder="Search by name or email..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
        </div>

        <div>
  <ul className={styles.invoicelist}>
    <li>Name</li>
    <li>Email</li>
    <li>Tin</li>
    <li>Address</li>
    <li>PhoneNumber</li>
    <li>Action</li>
  </ul>

  {currentContacts.map((contact) => (
    <ul key={contact.contactId} className={styles.invoicelistitem}>
      <li>{contact.customerName}</li>
      <li>{contact.customerEmail}</li>
      <li>{contact.customerTin}</li>
      <li>{contact.customerAddress}</li>
      <li>{contact.customerPhoneNumber}</li>
      <li style={{ display: "flex", gap: "5px" }}>
        {/* ✏️ Edit Button */}
        <img
          src={EditIcon} // import your Edit icon at the top
          alt="edit"
          id={styles.edit}
          onClick={() => handleEdit(contact)}
          style={{ cursor: "pointer" }}
        />

        {/* 🗑️ Delete Button */}
        <img
          src={DeleteIcon}
          alt="delete"
          id={styles.delete}
          onClick={() => handleDelete(contact.contactId)}
          style={{ cursor: "pointer" }}
        />
      </li>
    </ul>
  ))}
</div>


        <div id={styles.invoicelistnav}>
          <p>
            Showing {indexOfFirst + 1} to{" "}
            {Math.min(indexOfLast, filteredContacts.length)} of{" "}
            {filteredContacts.length} entries
          </p>
          <div id={styles.invoicenavbtn}>
            <button
              type="button"
              id={styles.prevbtn}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <button
              type="button"
              id={styles.nextbtn}
              onClick={() =>
                setCurrentPage((prev) =>
                  prev < totalPages ? prev + 1 : prev
                )
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
{isEditModalOpen && (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>Edit Contact</h2>
        <label>Name:</label>
        <input
          type="text"
          name="customerName"
          value={selectedContact.customerName}
          onChange={handleEditChange}
        />

        <label>Email:</label>
        <input
          type="email"
          name="customerEmail"
          value={selectedContact.customerEmail}
          onChange={handleEditChange}
        />

        <label>Address:</label>
        <input
          type="text"
          name="customerAddress"
          value={selectedContact.customerAddress}
          onChange={handleEditChange}
        />

        <label>Phone:</label>
        <input
          type="text"
          name="customerPhoneNumber"
          value={selectedContact.customerPhoneNumber}
          onChange={handleEditChange}
        />
<label>Tin:</label>
        <input
          type="text"
          name="customerTin"
          value={selectedContact.customerTin}
          onChange={handleEditChange}
        />
        <div className={styles.modalActions}>
          <button onClick={handleSaveEdit}>Save</button>
          <button onClick={() => setIsEditModalOpen(false)}>Cancel</button>
        </div>
      </div>
    </div>
  )}


      {/* Create New Contact Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add A Contact Detail</Modal.Title>
        </Modal.Header>
        <form>
          <Modal.Body>
            <div>
              <Modal.Title>Name</Modal.Title>
              <input
                type="text"
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
                value={name}
              />
              <Modal.Title>Email</Modal.Title>
              <input
                type="text"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                value={email}
              />
              <Modal.Title>Address</Modal.Title>
              <input
                type="text"
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Address"
                value={address}
              />
              <Modal.Title>PhoneNumber</Modal.Title>
              <input
                type="text"
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="PhoneNumber"
                value={phonenumber}
              />
              <Modal.Title>Tin:</Modal.Title>
              <input
                type="text"
                onChange={(e) => setNewTin(e.target.value)}
                placeholder="Tin"
                value={newTin}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}

export default Contact;
